
import { put, call, takeLeading } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { ApiRequest } from '../../utils/apiRequest';
import Swal from "sweetalert2";
import { api_url,workshop_list, create_workshop, change_workshop_status,change_workshop_admin_status, update_workshop, delete_workshop } from '../../utils/Constants';
import { Colors } from "../../assets/styles";


function* addWorkshop(actions) {
  try {
    const { payload } = actions;
    yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
    const response = yield ApiRequest.postRequest({
      url: api_url + create_workshop,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: payload,
    });

    if (response?.success) {
      Swal.fire({
        icon: "success",
        title: "Workshop Added Successfully",
        showConfirmButton: false,
        timer: 2000,
      });
      yield put({ type: actionTypes.WORKSHOP_LIST, payload: response});
      yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
    } else if (response.error) {
      const errorMessage = response.error.message || "Server Error";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
        showConfirmButton: false,
        timer: 2000,
      });
    }
    yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
  } catch (e) {
    yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
    console.log(e);
    Swal.fire({
      icon: "error",
      title: "Unexpected Error Occured",
      text: e.message ,
      showConfirmButton: false,
      timer: 2000,
    });
    yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
  }
}

function* getAllWorkshop() {
  try {
    yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
    const response = yield call(ApiRequest.getRequest, {
      url: api_url + workshop_list,
    });


    if (response) {
      yield put({
        type: actionTypes.WORKSHOP_LIST,
        payload: response?.data,
      });
    }
    yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
  } catch (e) {
        yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
    console.log(e);
  }
}
function* updateWorkshopStatus(action) {
  try {
      const { payload } = action;
      yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
      const response = yield ApiRequest.postRequest({
          url: api_url + change_workshop_status,
          header: "json",
          data: payload,
      });
      if (response && response.success) {
        Swal.fire({
          icon: "success",
          title: "Workshop Status Updated Successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        yield put({ type: actionTypes.WORKSHOP_LIST, payload: response });
        yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
      } else {
        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: "Status Updation Failed",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } catch (error) {
      console.error('Error Updating Workshop Status:', error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to Change Workshop Status",
        showConfirmButton: false,
        timer: 2000,
      });
    } finally {
      yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
    }
}
function* updateWorkshopAdminStatus(action) {
  try {
      const { payload } = action;
      yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
      const response = yield ApiRequest.postRequest({
          url: api_url + change_workshop_admin_status,
          header: "json",
          data: payload,
      });
      if (response && response.success) {
        Swal.fire({
          icon: "success",
          title: "Status Updated Successfully",
          showConfirmButton: false,
          timer: 2000,
        });
        yield put({ type: actionTypes.WORKSHOP_LIST, payload: response });
        
      } else {
        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: "Status Updation Failed",
          showConfirmButton: false,
          timer: 2000,
        });
      }
      yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
    } catch (error) {
      console.error('Error Updating Status:', error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to Change Status",
        showConfirmButton: false,
        timer: 2000,
      });
      yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
    } finally {
      yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
    }
}
function* updateWorkshop(actions) {
  try {
    const { payload } = actions;
    yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
    
    const response = yield ApiRequest.postRequest({
      url: api_url+update_workshop,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: payload,
    });

    if (response.success) {
      Swal.fire({
        icon: "success",
        title: "Workshop Updated Successfully",
        showConfirmButton: false,
        timer: 2000,
      });
      yield put({ type: actionTypes.WORKSHOP_LIST, payload: response });
    } else {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Workshop Update Failed",
        showConfirmButton: false,
        timer: 2000,
      });
    }
    yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
  } catch (e) {
    yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
    console.log(e);
  }
}
function* deleteWorkshop(actions) {
  try {
    const { payload } = actions;
    const result = yield Swal.fire({
      title: `Are you sure to Delete Workshop`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: Colors.primaryLight,
      cancelButtonColor: Colors.red,
      confirmButtonText: "Delete",
    })
    
    if (result.isConfirmed) {
      yield put({ type: actionTypes.SET_IS_LOADING, payload: true });

      const response = yield ApiRequest.postRequest({
        url: api_url + delete_workshop,
        header: "json",
        data: {
          workshopId: payload?.workshopId

        },
      });
  
      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Workshop Deleted Successfull",
          showConfirmButton: false,
          timer: 2000,
        });
        yield put({ type: actionTypes.WORKSHOP_LIST, payload: response });

      } else {
        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: "Workshop Delete Failed",
          showConfirmButton: false,
          timer: 2000,
        });
      }
    }

  
    yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
  } catch (e) {
    yield put({ type: actionTypes.UNSET_IS_LOADING , payload: false });
    console.log(e);
  }
}
export default function* workshopSaga() {
  yield takeLeading(actionTypes.CREATE_WORKSHOP, addWorkshop);
  yield takeLeading(actionTypes.WORKSHOP_LIST, getAllWorkshop);
  yield takeLeading(actionTypes.UPDATE_WORKSHOP, updateWorkshop);
  yield takeLeading(actionTypes.UPDATE_WORKSHOP_STATUS, updateWorkshopStatus);
  yield takeLeading(actionTypes.UPDATE_WORKSHOP_ADMIN_STATUS, updateWorkshopAdminStatus);
  yield takeLeading(actionTypes.DELETE_WORKSHOP, deleteWorkshop);
}
